import { useEffect } from 'react';
import { useTitle } from '../../context/TitleContext';
import { Row, Col } from 'react-bootstrap';
import AddOffer from './components/AddOffer';
import '../../styles/products.scss';

const OfferCreate = () => {
  const { setTitle } = useTitle();

  useEffect(() => {
    setTitle('Créer une Offre');
  }, [setTitle]);

  return (
    <div className="offer-create-page">
      <Row className="g-3">
        <Col xl={12} lg={12}>
          <AddOffer />
        </Col>
      </Row>
    </div>
  );
};

export default OfferCreate;
